/* eslint-disable @typescript-eslint/no-explicit-any */
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {merchantApiClient} from '#lib/api-client';
import {queryKeys} from '#lib/query-client';

// Hook for subscribing to merchant organisation
export function useSubscribeMerchantOrganisation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string | number) =>
      merchantApiClient.subscribeMerchantOrganisation({id}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: queryKeys.merchant.all});
    }
  });
}

// Hook for unsubscribing from merchant organisation
export function useUnsubscribeMerchantOrganisation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string | number) =>
      merchantApiClient.unsubscribeMerchantOrganisation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: queryKeys.merchant.all});
    }
  });
}

// Hook for accepting merchant organisation request
export function useAcceptMerchantOrganisationRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string | number) =>
      merchantApiClient.acceptMerchantOrganisationRequest(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: queryKeys.merchant.all});
    }
  });
}

// Hook for declining merchant organisation request
export function useDeclineMerchantOrganisationRequest() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string | number) =>
      merchantApiClient.declineMerchantOrganisationRequest(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: queryKeys.merchant.all});
    }
  });
}

// Hook for bulk unsubscribing from merchant organisations
export function useBulkUnsubscribeMerchantOrganisation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Record<string, any>) =>
      merchantApiClient.bulkUnsubscribeMerchantOrganisation(data),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: queryKeys.merchant.all});
    }
  });
}
